import { render, staticRenderFns } from "./HeaderNews.vue?vue&type=template&id=212a0f47&scoped=true"
import script from "./HeaderNews.vue?vue&type=script&lang=js"
export * from "./HeaderNews.vue?vue&type=script&lang=js"
import style0 from "./HeaderNews.vue?vue&type=style&index=0&id=212a0f47&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a0f47",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Back: require('/vercel/path0/components/elements/Back.vue').default})
